import React from 'react';
import { IssuerSnapshot } from '../../types/billing';

/** A4/Letter sheet wrapper honouring the document's saved appearance settings. */
export function BillingSheet({
  issuer,
  children
}: {
  issuer: IssuerSnapshot;
  children: React.ReactNode;
}) {
  const {
    appearance
  } = issuer;
  const width = appearance.paperSize === 'A4' ? '210mm' : '216mm';
  const minHeight = appearance.paperSize === 'A4' ? '297mm' : '279mm';
  return <article className="flex flex-col bg-white text-[11px] text-slate-900" style={{
    width,
    minHeight,
    padding: `${appearance.marginMm}mm`,
    fontFamily: `'${appearance.font}', Arial, sans-serif`
  }} data-id="element-3041" data-mp="354j5ej8ijxwk">
      {children}
    </article>;
}